import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { QualificationSection } from '../components/QualificationSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { LocationsSection } from '../components/LocationsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-227">
      <Header data-id="element-228" />
      <main data-id="element-229">
        <HeroSection data-id="element-230" />
        <TrustBar data-id="element-231" />
        <QualificationSection data-id="element-232" />
        <ServicesSection data-id="element-233" />
        <ProcessSection data-id="element-234" />
        <AboutSection data-id="element-235" />
        <LocationsSection data-id="element-236" />
        <FAQSection data-id="element-237" />
        <CTASection data-id="element-238" />
      </main>
      <Footer data-id="element-239" />
    </div>;
}